import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal, MaskedLines } from "../components/Motion";
import { CtaBand } from "../components/CtaBand";
import { useLang } from "../i18n/LanguageContext";
import { SITE_URL } from "../data/content";

export default function Blog() {
  const { t, data } = useLang();
  const b = t.blog;
  const schema = {
    "@context": "https://schema.org",
    "@type": "Blog",
    url: `${SITE_URL}/blog`,
    name: "SG Language Services Blog",
    blogPost: data.BLOG_POSTS.map((p) => ({
      "@type": "BlogPosting",
      headline: p.title,
      datePublished: p.date,
      url: `${SITE_URL}/blog/${p.slug}`
    }))
  };

  return (
    <>
      <Seo title={b.seoTitle} description={b.seoDesc} path="/blog" schema={schema} />
      <section className="max-w-7xl mx-auto px-6 lg:px-12 pt-16 lg:pt-24 pb-28 texture-grain" data-testid="blog-page">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-periwinkle-deep mb-6">{b.kicker}</p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.0] tracking-tight max-w-4xl">
          <MaskedLines lines={b.heroLines} />
        </h1>

        <div className="mt-20 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.BLOG_POSTS.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.1}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block bg-white border border-ink/10 rounded-lg overflow-hidden hover:border-periwinkle transition-colors duration-300 h-full">
                <div className="overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-52 object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-8">
                  <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted2">{p.date} · {p.readTime}</p>
                  <h2 className="font-serif text-2xl font-semibold mt-4 leading-snug flex items-start gap-2">
                    {p.title}
                    <ArrowUpRight size={18} className="text-periwinkle-deep shrink-0 mt-1.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </h2>
                  <p className="text-sm text-muted2 leading-relaxed mt-3">{p.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CtaBand />
    </>
  );
}
